import MultiStepform from 'Components/organisms/MultiStepForm/MultiStepForm';
import styled from 'styled-components';

export const StyledMultiStepForm = styled(MultiStepform) `
    form {
        padding: 0;
    }
`;